import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFault = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 22.025c-.267 0-.52-.05-.762-.15a2.247 2.247 0 0 1-.663-.425L2.55 13.425c-.183-.2-.325-.42-.425-.663-.1-.241-.15-.495-.15-.762s.05-.525.15-.775c.1-.25.242-.467.425-.65l8.025-8.025c.2-.2.42-.346.663-.438a2.234 2.234 0 0 1 1.537 0c.25.092.467.238.65.438l8.025 8.025c.2.183.346.4.438.65a2.233 2.233 0 0 1 0 1.537 1.875 1.875 0 0 1-.438.663l-8.025 8.025c-.183.183-.4.325-.65.425-.25.1-.508.15-.775.15zM12 13c.283 0 .52-.096.713-.287A.968.968 0 0 0 13 12V8a.967.967 0 0 0-.287-.713A.968.968 0 0 0 12 7a.968.968 0 0 0-.713.287A.967.967 0 0 0 11 8v4c0 .283.096.52.287.713.192.191.43.287.713.287zm0 3c.283 0 .52-.096.713-.287A.968.968 0 0 0 13 15a.967.967 0 0 0-.287-.713A.968.968 0 0 0 12 14a.968.968 0 0 0-.713.287A.967.967 0 0 0 11 15c0 .283.096.52.287.713.192.191.43.287.713.287z",
		fill: "currentColor"
	})
});
export default SvgFault;
